require('./index.jade')
$ = require('jquery')

GroupSearchItemDirective = ($filter ,$translate ) ->
  restrict: "EA"
  replace: true
  templateUrl: "groups/group-search-item-directive/index.jade"
  scope:
    data: '=data'
    requestGroup: '&requestGroup'
    clickDetail: '&clickDetail'
  link: (scope) ->
    scope.displayMember = (member) ->
      ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'))

    scope.displayRequest = (member) ->
      if member
        return scope.data.user_status == 'approved'
      (scope.data.user_status == 'approved' || scope.data.user_status == 'pending')

GroupSearchItemDirective.$inject = [
  '$filter'
  '$translate'
]

module.exports = GroupSearchItemDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-search-item-directive/group-search-item-directive.coffee